import Results from './results';

export default Results;
